import { Facebook, Instagram, Youtube, Linkedin, MapPin } from "lucide-react";
import { useSettings } from "@/contexts/SettingsContext";

// Simple icons for TikTok / Pinterest / Houzz (lucide doesn't ship them)
const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" {...props}>
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.74a8.16 8.16 0 0 0 4.77 1.52V6.81a4.85 4.85 0 0 1-1.84-.12Z" />
  </svg>
);
const PinterestIcon = (props) => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" {...props}>
    <path d="M12 2C6.48 2 2 6.48 2 12c0 4.13 2.5 7.66 6.07 9.18-.08-.78-.16-1.97.03-2.82.18-.77 1.17-4.9 1.17-4.9s-.3-.6-.3-1.49c0-1.39.81-2.43 1.81-2.43.86 0 1.27.64 1.27 1.41 0 .86-.55 2.14-.83 3.33-.24 1 .5 1.81 1.49 1.81 1.79 0 3.16-1.89 3.16-4.61 0-2.41-1.73-4.1-4.21-4.1-2.87 0-4.55 2.15-4.55 4.37 0 .87.33 1.8.75 2.31a.3.3 0 0 1 .07.29l-.27 1.1c-.04.18-.14.22-.33.13-1.21-.56-1.96-2.32-1.96-3.74 0-3.04 2.21-5.83 6.37-5.83 3.34 0 5.94 2.38 5.94 5.57 0 3.32-2.1 6-5.01 6-.98 0-1.9-.51-2.21-1.11l-.6 2.29c-.22.84-.81 1.89-1.21 2.53.91.28 1.88.43 2.89.43 5.52 0 10-4.48 10-10S17.52 2 12 2z" />
  </svg>
);
const HouzzIcon = (props) => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" {...props}>
    <path d="M7 2v8l5-3 5 3v12H7V2z" />
  </svg>
);
const GoogleIcon = (props) => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" {...props}>
    <path d="M21.35 11.1H12v3.2h5.35c-.23 1.5-1.7 4.4-5.35 4.4-3.22 0-5.85-2.66-5.85-5.95s2.63-5.95 5.85-5.95c1.83 0 3.06.78 3.76 1.45l2.57-2.47C16.71 4.36 14.6 3.4 12 3.4 6.93 3.4 2.8 7.53 2.8 12.6s4.13 9.2 9.2 9.2c5.31 0 8.83-3.74 8.83-9 0-.6-.06-1.05-.18-1.7z" />
  </svg>
);

export default function SocialIcons({ size = 18, className = "", testIdPrefix = "social" }) {
  const { settings } = useSettings();

  const items = [
    { key: "facebook", url: settings.facebook_url, Icon: Facebook, label: "Facebook" },
    { key: "instagram", url: settings.instagram_url, Icon: Instagram, label: "Instagram" },
    { key: "youtube", url: settings.youtube_url, Icon: Youtube, label: "YouTube" },
    { key: "linkedin", url: settings.linkedin_url, Icon: Linkedin, label: "LinkedIn" },
    { key: "tiktok", url: settings.tiktok_url, Icon: TikTokIcon, label: "TikTok" },
    { key: "pinterest", url: settings.pinterest_url, Icon: PinterestIcon, label: "Pinterest" },
    { key: "houzz", url: settings.houzz_url, Icon: HouzzIcon, label: "Houzz" },
    { key: "google", url: settings.google_business_url, Icon: GoogleIcon, label: "Google" },
  ].filter((i) => !!i.url);

  if (items.length === 0) return null;

  return (
    <div className={`flex items-center gap-5 ${className}`}>
      {items.map(({ key, url, Icon, label }) => (
        <a
          key={key}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          data-testid={`${testIdPrefix}-${key}`}
          className="text-ink-muted hover:text-brand transition-colors"
        >
          <Icon size={size} />
        </a>
      ))}
    </div>
  );
}
